if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.drawer = this.closest('.custom-menu-drawer');
        this.isDrawerForm = Boolean(this.closest('.custom-menu-drawer__localization'));
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.panelHome = this.elements.panel ? this.elements.panel.parentElement : null;
        this.panelOpening = false;

        if (!this.elements.button || !this.elements.panel) return;

        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.closeSelector.bind(this));
        this.elements.button.addEventListener('click', this.onButtonClick.bind(this));

        if (this.mql.matches && !this.isDrawerForm) {
          this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
          this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        }

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }
        this.querySelectorAll('.country-selector__close-button, .language-selector__close-button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.hidePanel();
          });
        });
        this.querySelectorAll('.custom-menu-drawer__localization-panel-close, .custom-menu-drawer__localization-panel-header .custom-menu-drawer__close').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.hidePanel();
          });
        });
        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      isMobileMode() {
        return this.isDrawerForm || !this.mql.matches;
      }

      mountPanel() {
        if (!this.isDrawerForm || !this.elements.panel || this.elements.panel.parentElement === document.body) return;
        this.elements.panel.classList.add('custom-menu-drawer__localization-panel');
        document.body.appendChild(this.elements.panel);
      }

      unmountPanel() {
        if (!this.isDrawerForm || !this.elements.panel || !this.panelHome) return;
        this.elements.panel.classList.remove('custom-menu-drawer__localization-panel');
        if (this.elements.panel.parentElement === document.body) {
          this.panelHome.appendChild(this.elements.panel);
        }
      }

      onMouseEnter() {
        if (this.mql.matches && !this.isDrawerForm) {
          if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
          }
          this.showPanel();
        }
      }

      onMouseLeave(event) {
        if (this.mql.matches && !this.isDrawerForm) {
          
          const relatedTarget = event.relatedTarget;
          if (!this.contains(relatedTarget)) {
            
            this.closeTimeout = setTimeout(() => {
              this.hidePanel();
            }, 150);
          }
        }
      }

      containsNode(node) {
        if (!node) return false;
        return this.contains(node) || (this.elements.panel && this.elements.panel.contains(node));
      }

      hidePanel() {
        if (!this.elements.panel || !this.elements.button) return;

        this.panelOpening = false;
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', '');
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }
        document.body.classList.remove('overflow-hidden-mobile');
        const menuDrawer = this.drawer || document.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.remove('country-selector-open', 'localization-panel-open');
        if (this.header) this.header.preventHide = false;
        this.unmountPanel();
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button.focus();
            break;
          case 'SPACE':
            if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
            this.showPanel();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      showPanel() {
        if (!this.elements.panel || !this.elements.button || !this.elements.panel.hasAttribute('hidden')) return;

        this.panelOpening = true;
        this.mountPanel();
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        const menuDrawer = this.drawer || document.querySelector('.menu-drawer');
        if (menuDrawer) {
          menuDrawer.classList.add(this.isDrawerForm ? 'localization-panel-open' : 'country-selector-open');
        }

        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }

        if (this.isDrawerForm) {
          const backButton = this.elements.panel.querySelector(
            '.country-selector__close-button, .language-selector__close-button'
          );
          if (backButton) {
            backButton.focus();
          }
        } else if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        } else {
          this.elements.button.focus();
        }

        requestAnimationFrame(() => {
          this.panelOpening = false;
        });
      }

      onButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.elements.panel) return;

        if (this.elements.panel.hasAttribute('hidden')) {
          this.showPanel();
          return;
        }

        if (this.isMobileMode()) {
          this.hidePanel();
        }
      }

      closeSelector(event) {
        if (this.panelOpening) return;

        if (event.target.classList.contains('country-selector__overlay')) {
          this.hidePanel();
          return;
        }

        const relatedTarget = event.relatedTarget;

        if (!relatedTarget) return;

        if (!this.containsNode(event.target) || !this.containsNode(relatedTarget)) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        this.querySelector('.country-selector').scrollTop = 0;
        this.querySelector('.country-selector__list').scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
